import React from 'react';
import GlobalControls from './components/GlobalControls';
import ComplianceMetrics from './components/ComplianceMetrics';
import QualityTrendsChart from './components/QualityTrendsChart';
import ComplianceChecklist from './components/ComplianceChecklist';
import ComplianceGrid from './components/ComplianceGrid';

const QualityCompliancePage = () => {
  return (
    <div className="min-h-screen bg-background">
      {/* El <Header /> fue removido de aquí */}
      
      <main className="pt-16">
        <div className="max-w-7xl mx-auto px-6 py-8">
          {/* Global Controls */}
          <GlobalControls />

          {/* Top Metrics Row */}
          <div className="mb-8">
            <ComplianceMetrics />
          </div>

          {/* Main Content Grid */}
          <div className="grid grid-cols-1 xl:grid-cols-16 gap-6 mb-8">
            {/* Central Visualization Area - 12 columns */}
            <div className="xl:col-span-12">
              <QualityTrendsChart />
            </div>

            {/* Side Panel - 4 columns */}
            <div className="xl:col-span-4">
              <ComplianceChecklist />
            </div>
          </div>

          {/* Detailed Compliance Grid */}
          <div className="mb-8">
            <ComplianceGrid />
          </div>
        </div>
      </main>
    </div>
  );
};

export default QualityCompliancePage;